export const grey = "#E4E4E4";
export const green = "#179475";
export const graphite = "#36373c";
export const white = "#ffffff";